import { mobileApiRequest, workspaceActionsRequest } from '../../apiRequests'

export const getUsers = async (search) => {
    const action = {
        action: 'getObjects',
        class: 'scoop.user.User',
        filters: [{ field: 'userName', op: 'LIKE', value: `%${search}%` }],
    }
    const result = await mobileApiRequest(action)
    return result?.objects || []
}

export const getWorkspaces = async (search, searchBy = 'name') => {
    const field = searchBy === 'id' ? 'workspaceID' : 'name'
    const action = {
        action: 'getObjects',
        class: 'scoop.workspace.Workspace',
        ...(search && {
            filters: [{ field, op: 'LIKE', value: `%${search}%` }],
        }),
    }
    const result = await mobileApiRequest(action)
    return result?.objects || []
}

export const getWorkspacesForUser = async (userID) => {
    const action = {
        action: 'getObjects',
        attributeName: 'userID',
        class: 'scoop.workspace.Workspace',
        attributeValue: userID,
        relatedClass: 'scoop.workspace.WorkspaceUser',
        userID: userID,
    }
    const result = await mobileApiRequest(action)
    return result?.objects || []
}

export const addUserToWorkspace = async ({ workspaceID, userID, role }) => {
    const action = {
        action: 'putObject',
        class: 'scoop.workspace.WorkspaceUser',
        value: { workspaceID, userID, role },
    }
    return await mobileApiRequest(action)
}

export const removeUserFromWorkspace = async ({ workspaceID, userID }) => {
    const action = {
        action: 'deleteObject',
        class: 'scoop.workspace.WorkspaceUser',
        keyParts: [workspaceID, userID],
    }
    return await mobileApiRequest(action)
}

export const createWorkspace = async ({ workspaceName, userName, userID }) => {
    const action = {
        action: 'createWorkspace',
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        workspaceName,
        userName,
        userID,
    }
    return await workspaceActionsRequest(action)
}

export const getWorkspaceInboxes = async (workspaceID) => {
    const action = {
        action: 'getInboxInformation',
        workspaceID,
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
    }
    return await mobileApiRequest(action)
}

export const clearAICache = async ({ workspaceID, userID, inboxID }) => {
    const action = {
        action: 'clearAICache',
        workspaceID,
        userID,
    }
    if (inboxID) action.inboxID = inboxID
    return await mobileApiRequest(action)
}
